import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NavService } from '../../_services/_nav.service';
import { Table } from 'primeng/table';
import { ConfiguracionUrlExterna } from '../../_models/configuracion-url-externa';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { Producto } from '../../_models/producto';
import { ProductoAlerta } from '../../_models/producto-alerta';
import { ProductoAlertaService } from '../../_services/producto-alerta.service';

@Component( {
  selector: 'app-producto-alertas-listado',
  templateUrl: 'producto-alertas-listado.component.html'
} )

export class ProductoAlertasListadoComponent implements OnInit {

  @Input() producto: Producto;
  @Input() visualizar:boolean;
  @ViewChild('dt') tabla: Table;

  public editando:boolean = false;
  public cargaInicial:boolean = true;
  public errorConfiguracion = false;
  public idProductoAlertaEditar:string;

  //Variables del datatable
  public numRegistros:number;
  public buscando: boolean;
  public columnas: any[] = [];
  public listaProductoAlertas: ProductoAlerta[] = [];

  //Buscador
  public busqueda:string;

  //Paginacion
  page = '0';
  rowsPerPage = 10;
  rowsCount = 10;

  constructor(private navService:NavService,
              private router:Router,
              private confirmService:ConfirmationService,
              private productosAlertaService:ProductoAlertaService){
  }

  ngOnInit(): void {
    console.log(this.visualizar);
    this.getRecords();
    this.inicializarTabla();
  }

  private inicializarTabla(){

    this.columnas = [
      { field: 'codigoAlerta', header: this.navService.buscarMensaje( 'PRODUCTOSALERTA.LBL_ALERTA' ), sort: false },
      { field: 'indicadorNoAplica', header: this.navService.buscarMensaje( 'PRODUCTOSALERTA.LBL_NOAPLICA' ), sort: false },
      { field: 'indicadorHabilitado', header: this.navService.buscarMensaje( 'PRODUCTOSALERTA.LBL_HABILITADO' ), sort: false },
      { field: 'acciones', header: this.navService.buscarMensaje( 'PRODUCTOSALERTA.LBL_ACCIONES' ), sort: false },
    ];
  }

  private getRecords(){
    this.buscando = true;
    this.productosAlertaService.listadoPorIdProducto(this.producto.idProducto).subscribe( lstProdAlerta => {
      this.listaProductoAlertas = lstProdAlerta;
      this.buscando = false;
    });
  }

  public agregarNuevaAlerta(){
    this.idProductoAlertaEditar = null;
    this.editando = true;
  }

  public setBusqueda() {
    this.navService.setSearch( 'productos-alerta.component', this.busqueda );
  }

  public editarAlerta(prodAlerta:ProductoAlerta){
    this.idProductoAlertaEditar = prodAlerta.idProductoAlerta;
    this.editando = true;
  }

  public mostrarListado(event:any){
    this.getRecords();
    this.editando = false;
  }
}
